import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {Button} from '@goguardian/based';
import qs from 'query-string';

import style from './style.scss';

class PreSignup extends React.Component {
  componentDidMount() {
    const params = qs.parse(window.location.search);
    const userData = {};

    /**
     * If a campaign exists, we want to include the
     * utm params in the identify call.
     */
    if (params.utm_campaign) {
      userData.utmCampaign = params.utm_campaign;
      userData.utmContent = params.utm_content;
      userData.utmMedium = params.utm_medium;
      userData.utmSource = params.utm_source;
      userData.utmTerm = params.utm_term;
    }

    if (window.analytics) analytics.identify(userData);
  }

  redirect(product) {
    if (product === 'admin')
      this.props.router.replace({
        pathname: '/product/admin'
      });
    
    if (product === 'teacher')
      this.props.router.replace({
        pathname: '/other',
        search: window.location.search
      });
  }

  render() {
    return (
      <div className={style.startContainer}>
        <h1>What is your role?</h1>
        <br />
        <Button
          onClick={this.redirect.bind(this, 'admin')}
          block
        >
          Tech Admin
        </Button>
        <br />
        <Button
          onClick={this.redirect.bind(this, 'teacher')}
          block
        >
          Teacher/Other
        </Button>
      </div>
    );
  }
};

export default connect()(withRouter(PreSignup));



/** WEBPACK FOOTER **
 ** ./src/app/components/signup/index.jsx
 **/